import { Status } from '../../../models/common';
import { createStringIdAdapter } from './string-id-adapter';

export const statusAdapter = createStringIdAdapter<Status>();
